/** @format */

import React, { Component,Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import intl from 'react-intl-universal';
import ActionsBarPres from '../presentational/ActionsBarPres';
import {
  QUESTIONNAIRE_LANDING_URL,
  HOME_URL,
  //DOCUMENTS_TYPE_SELECTOR_URL,
  // PROFILE_URL,
  // NEED_ASSISTANCE_URL,
  // PAYMENT_METHOD_URL,
  CASE_DETAIL_URL,
} from 'src/constants/constants.js';
//import { handleTabChange } from 'src/ui/layout/TabNavigator/state/tabNavigatorActions';
import urlParamsMapper from 'src/helpers/urlParamsMapper.js';
//import { persistShowOrganizer, submitShowOrganizer, downloadQuestionnaire, persistOrg } from 'src/services/cms.service.js';
import { persistShowOrganizer, submitShowOrganizer, downloadQuestionnaire } from 'src/services/cms.service.js';
import { removeReadOnlyFromPayload, transformFormValues, saveAPIFile } from 'src/helpers';
import { CREATEORGANIZER_PAGESTATES,QUESTIONNAIRE_PAGE_URL } from 'src/constants/constants';
import { withSnackbar } from 'notistack';
//import { SI_MENU_PAGESTATES } from 'src/constants/constants';
import {
  updateMenu,
  updateIsCompleteModalDialogOpenClose,
  showHideMoveAwayPopUp,
  // setChatTabClick,
  // setDocTabClick,
  // setHomeTabClick,
  // setValueMoveAwaySave,
  // toggleOpenCloseDrawer,
  showSpinnerEnableDisable,
  displaySavePOPUP,
  elementUpdated
} from 'src/ui/features/Questionnaire/state/questionnaireActions';
import { ConfirmDialog } from 'src/ui/library/Dialog';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';
//import { setPersistOrganizer, resetInitiation } from 'src/ui/features/ServiceInit/state/serviceInitActions';

//const isMenuComplete = status => status === SI_MENU_PAGESTATES.COMPLETE || status === SI_MENU_PAGESTATES.CURRENT_COMPLETE;

class ActionsBarContainer extends Component {
  static propTypes = {
    enqueueSnackbar: PropTypes.func.isRequired,
    setShowErrors: PropTypes.func,
    isPageVariant: PropTypes.bool,
    isMenuClicked: PropTypes.bool,
    resetMenuButtonClicked: PropTypes.func,
  };

  static defaultProps = {
    formValues: {},
    setShowErors: () => {},
    isPageVariant: false,
  };

  state = {
    isConfirmSubmitDialogOpen: false,
    isSubmittingQuestionnaire: false,
    isNextClicked: false,
    isForceDisabled: false,
    isMenuClicked: false,
    isHomeClicked: false,
    isSaveClicked: false,
    moveAwaySsaveInProgress: false,
  };

  constructor(props) {
    super(props);
    if (props.setSaveHandler) {
      props.setSaveHandler(this.handleSave);
    }

    if (props.getSaveFn) {
      props.getSaveFn(this.handleSave);
    }

    if (props.getforceDisableSubmitBtnFn) {
      props.getforceDisableSubmitBtnFn(this.updateForceDisableSubmitBtn);
    }
  }

  state = {
    isConfirmSubmitDialogOpen: false,
    isSubmittingQuestionnaire: false,
    isAlterDialogOpen: false,
    isNextClicked: false,
    isForceDisabled: false,
    afterSubmitError: '',
  };
  componentDidMount() {
    window.addEventListener('resize', this.handleKeyboardAvoiding);
  }
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleKeyboardAvoiding);
    this.props.elementUpdated(false);
    this.props.displaySavePOPUP(false);
  }

  handleKeyboardAvoiding = () => {
    const focusedElement = document.activeElement;
    if (focusedElement.tagName.toLowerCase() === 'input') {
      setTimeout(() => focusedElement.scrollIntoView({ behavior: 'smooth' }), 100);
    }
  };
  componentDidUpdate(prevProps) {
    if (this.props.menu.length !== prevProps.menu.length && this.state.isNextClicked) {
      const { menu, menuIndex, push } = this.props;
      if (menuIndex !== menu.length - 1) {
        const { url } = menu[menuIndex + 1];
        push(url);
      }
    }
  }
  handlePrevPage = event => {
    if(this.props.elementUD){  
      this.props.displaySavePOPUP(true);
    }else { 
    event && event.currentTarget.blur();  
    this.handleSave(false, false, false, () => {
      const { menu, menuIndex, push } = this.props;
      if (menu && menuIndex && menuIndex >= 0) {
        const { url } = menu[menuIndex - 1];
        //window.history.replaceState(null, '', url);
        push(url);
      }
    });
   }  
  };

  handleNextPage = event => {
      if(this.props.elementUD){  
      this.props.displaySavePOPUP(true);
    }else {
    event && event.currentTarget.blur();
    this.setState({ isNextClicked: true });
    this.handleSave(false, false, false, () => {
      const { menu, menuIndex, push } = this.props;
      if (menuIndex !== menu.length - 1) {
        const { url } = menu[menuIndex + 1];
        //window.history.replaceState(null, '', url);
        push(url);
      }
    });
    }
  };

  saveData = ()  => {
    this.props.displaySavePOPUP(false);
    this.props.elementUpdated(false)
    const { routeParams } = this.props;
    this.handleSave(push(urlParamsMapper(QUESTIONNAIRE_PAGE_URL, routeParams)))
  }

  cancelData = () => { 
    this.props.displaySavePOPUP(false);
    this.props.elementUpdated(false);
  }

  onSubmitModal = event => {
    event && event.currentTarget.blur();
    if (!this.state.isSaveClicked) {
      this.handleSave(false, true, true, () => {
        const { menu, menuIndex, push, routeParams } = this.props;
        if (this.state.isNextClicked) {
          if (menuIndex !== menu.length - 1) {
            const { url } = menu[menuIndex + 1];
            push(url);
          }
          this.setState({ isNextClicked: false });
        } else if (this.state.isMenuClicked) {
          if (routeParams) {
            push(urlParamsMapper(QUESTIONNAIRE_LANDING_URL, routeParams));
          }
          this.setState({ isMenuClicked: false });
        } else if (this.props.isMenuClicked) {
          if (routeParams) {
            push(urlParamsMapper(QUESTIONNAIRE_LANDING_URL, routeParams));
          }
          this.setState({ isMenuClicked: false });
        } else if (this.state.isHomeClicked) {
          if (routeParams) {
            push(HOME_URL);
          }
          this.setState({ isHomeClicked: false });
        } else if (this.props.isBackButtonClick) {
          window.history.back();
        } else if (this.props.chatTabClicked) {
          //   this.props.handleTabChange(TABS_NUMBER.CHATS);
          //   if (routeParams) {
          //     push(CHAT_URL);
          //   }
        } else if (this.props.homeTabClicked) {
          //   this.props.handleTabChange(TABS_NUMBER.HOME);
          //   if (routeParams) {
          //     push(HOME_URL);
          //   }
        } else if (this.props.docTabClicked) {
          //   this.props.handleTabChange(TABS_NUMBER.DOCUMENTS);
          //   if (routeParams) {
          //     push(DOCUMENTS_TYPE_SELECTOR_URL);
          //   }
        } else if (this.props.userProfileClick) {
          if (routeParams) {
            //this.props.toggleOpenCloseDrawer(!this.props.hamburgerDrawerOpenClose);
            // push(PROFILE_URL);
          }
        } else if (this.props.helpButtonClicked) {
          if (routeParams) {
            this.props.toggleOpenCloseDrawer(!this.props.hamburgerDrawerOpenClose);
            // push(NEED_ASSISTANCE_URL);
          }
        } else if (this.props.headerClicked) {
          if (routeParams) {
            push(HOME_URL);
          }
        } else {
          if (menuIndex > 0) {
            const { url } = menu[menuIndex - 1];
            push(url);
          } else if (menuIndex === 0) {
            window.history.back();
          }
        }
      });
    } else {
      this.handleSave(true, true, true, () => {});
    }
  };

  handleSave = async (
    showNotification = true,
    submitModal = false,
    hardReload = true,
    callback = () => {},
    spinner = true,
    isThisFormComplete,
  ) => {
    // there's nothing to save on a menu page. we'll revisit this later
    if (this.props.noSave) {
      return callback();
    }

    if (showNotification) {
      this.setState({ isSaveClicked: true });
    }

    const { enqueueSnackbar, routeParams, updateMenu, page } = this.props;
    let { formValues, isFormComplete } = this.props.formValues;
    if (isThisFormComplete !== undefined) {
      isFormComplete = isThisFormComplete;
    }
    const { organizerInstanceId, assigneeServicePlanGlobalId, yearTypeId, organizerTypeId, pageId, sourceTableId } = this.props.page;
    const pageState = isFormComplete ? CREATEORGANIZER_PAGESTATES.COMPLETE : CREATEORGANIZER_PAGESTATES.CURRENT_NOT_COMPLETE;

    // check required fields and turn on highlighting for missing fields + modal
    /*if (this.props.isPageVariant && !submitModal) {
      if (isFormComplete === false) {
        this.props.updateIsCompleteModalDialogOpenClose(true);
        this.props.showHideMoveAwayPopUp(true);
        return;
      }
    }*/
    const isCalWP = sessionStorage.getItem('isCalWP');
    formValues = removeReadOnlyFromPayload(formValues, page);

    const orgOptions = {
      assigneeServicePlanGlobalId,
      organizerInstanceId,
      organizerTypeId,
      yearTypeId,
      pageId,
      pageSourceId: sourceTableId,
      languageId: 1,
      pageState,
      isCalWP,
      ...transformFormValues(formValues),
    };

    this.props.showSpinnerEnableDisable(true);
    const result = await persistShowOrganizer(orgOptions);
    // const result = await persistOrg(orgOptions);
    this.props.showSpinnerEnableDisable(false);

    if (result && result.success) {
      updateMenu(result.response.menus, routeParams);

      enqueueSnackbar(intl.get('questionnaire.actionBar.saveSuccess'), {
        variant: 'success',
      });
      this.props.showHideMoveAwayPopUp(false);
      if (hardReload) {
        this.hardReload();
      }
      callback();
    }
  };
  hardReload = () => {
    setTimeout(() => {
      window.location.reload();
    }, 500);
  };
  handleMenuClick = () => {
      if(this.props.elementUD){  
      this.props.displaySavePOPUP(true);
    }else {
    this.setState({ isMenuClicked: true });
    this.handleSave(false, false, false, () => {
      const { push, routeParams } = this.props;
      if (routeParams) {
        push(urlParamsMapper(QUESTIONNAIRE_LANDING_URL, routeParams));
      }
    });
   }
  };

  handleCloseRedirectTo = () => {
      if(this.props.elementUD){  
      this.props.displaySavePOPUP(true);
    }else {
    this.setState({ isMenuClicked: true });  
    this.handleSave(false, false, false, () => {
      const { push, routeParams } = this.props;
      if (routeParams) {
        const headerDetailsObject = sessionStorage.getItem('headerDetails');
        const headerDetails = JSON.parse(headerDetailsObject);
        const caseManagerId = headerDetails.caseManagerId ? headerDetails.caseManagerId : sessionStorage.getItem('caseManagerId');
        push(`${CASE_DETAIL_URL}/${caseManagerId}`);
      }
    });
   } 
  };

  handleHomeClick = () => {
    this.setState({ isHomeClicked: true });
    this.handleSave(false, false, false, () => {
      const { push, routeParams } = this.props;
      if (routeParams) {
        push(HOME_URL);
      }
    });
  };

  handleDownloadQuestionnaire = async type => {
    try {
      const { assigneeServicePlanGlobalId, organizerTypeId, yearTypeId } = this.props.introData;
      if (this.props.showSpinner === true) {
        return;
      }

      const isCalWP = type === 'DOWNLOAD_EY_PDF' ? true : false;
      const orgOptions = {
        assigneeServicePlanGlobalId,
        organizerTypeId,
        languageId: 1,
        yearTypeId,
        isCalWP,
      };

      this.props.showSpinnerEnableDisable(true);
      let response = await downloadQuestionnaire(orgOptions);
      if (response && response.success) {
        saveAPIFile(response.attachmentData, response.fileName);
        this.props.showSpinnerEnableDisable(false);
        this.hardReload();
      }

      // this.handleSave(
      //   false,
      //   true,
      //   false,
      //   async () => {
      //     this.props.showSpinnerEnableDisable(true);
      //     let response = await downloadQuestionnaire(orgOptions);
      //     if (response && response.success) {
      //       saveAPIFile(response.attachmentData, response.fileName);
      //       this.props.showSpinnerEnableDisable(false);
      //       this.hardReload();
      //     }
      //   },
      //   false,
      // );
    } catch (err) {
      this.props.showSpinnerEnableDisable(false);
    }
  };

  handleSubmit = () => {
    this.props.showHideMoveAwayPopUp(false);

    this.handleSave(
      false,
      false,
      false,
      async () => {
        const { enqueueSnackbar } = this.props;
        const { assigneeServicePlanGlobalId, organizerTypeId } = this.props.page;
        const orgOptions = {
          assigneeServicePlanGlobalId,
          organizerTypeId,
          languageId: 1,
        };
        this.props.showSpinnerEnableDisable(true);
        this.setState({ isSubmittingQuestionnaire: true });
        let result = await submitShowOrganizer(orgOptions);

        if (result && result.success) {
          enqueueSnackbar(intl.get('questionnaire.actionBar.infoSubmitted'), {
            variant: 'success',
          });

          //const { routeParams, handleTabChange } = this.props;
          const { push } = this.props;
          if (result.status) {
            let amount = Number(result.status.amount);
            if (Number.isNaN(amount) || amount === 0) {
              push(HOME_URL);
            } else {
              sessionStorage.setItem('paymentId', result.status.paymentId);
              // push(PAYMENT_METHOD_URL);
            }
          } else {
            /*  if (routeParams) {
              // handleTabChange(TABS_NUMBER.DOCUMENTS);
              // push(DOCUMENTS_TYPE_SELECTOR_URL);
            } */
          }
        } else if (result && result.error && result.error.code === 422) {
          this.setState({ afterSubmitError: result.error.message });
          this.toggleAlertSubmitDialog();
        }
        this.setState({ isSubmittingQuestionnaire: false });

        this.toggleConfirmSubmitDialog();
        this.updateForceDisableSubmitBtn(true);
        this.props.showSpinnerEnableDisable(false);
        this.props.onSubmitComplete();
      },
      false,
    );
  };

  updateForceDisableSubmitBtn = isForceDisable => {
    this.setState({ isForceDisabled: isForceDisable });
  };

  checkSubmitEnabled = () => {
    const { page } = this.props;
    let isSubmitEnabled = true;

    if (page) {
      return isSubmitEnabled && !page.isSubmitted;
    }
    return isSubmitEnabled;
  };

  toggleConfirmSubmitDialog = event => {
    event && event.currentTarget.blur();
    this.setState(prevState => ({
      isConfirmSubmitDialogOpen: !prevState.isConfirmSubmitDialogOpen,
    }));
  };
  toggleAlertSubmitDialog = () =>
    this.setState(prevState => ({
      isAlterDialogOpen: !prevState.isAlterDialogOpen,
    }));

  toggleCompleteModalDialog = () => {
    this.props.updateIsCompleteModalDialogOpenClose(!this.props.isCompleteModalDialogOpen);
    this.props.showHideMoveAwayPopUp(!this.props.showModal);
  };

  cancelModal = () => {
    this.props.updateIsCompleteModalDialogOpenClose(!this.props.isCompleteModalDialogOpen);
    this.props.showHideMoveAwayPopUp(!this.props.showModal);
    this.setState({
      isNextClicked: false,
      isMenuClicked: false,
      isSaveClicked: false,
      isHomeClicked: false,
    });
    this.props.resetMenuButtonClicked();
    this.props.setShowErrors();

    // this.handleSave(false, true, () => {
    //   if (this.props.reloadPage === true) {
    //     window.location.reload();
    //   }
    // })
  };

  render() {
    const { menuIndex, menu } = this.props;

    return (
      <Fragment>
      {this.props.displayPU && (<ConfirmDialog
          open={this.props.displayPU}
          cancelText={intl.get('questionnaire.assignNew.warning.cancel')}
          confirmText={intl.get('questionnaire.assignNew.warning.save')}
          onCancel={this.cancelData}
          onConfirm={this.saveData}
          >
          {<h1><ReportProblemIcon/>{"  OOPS!"}</h1>}
          <div>{intl.get('questionnaire.priceConfirmDialogTitle')}</div>
        </ConfirmDialog>)
      }
      <ActionsBarPres
        onSubmit={this.handleSubmit}
        onMenu={this.handleMenuClick}
        onSave={this.handleSave}
        onHome={this.handleHomeClick}
        onCloseWithAction={this.handleCloseRedirectTo}
        onDownload={this.handleDownloadQuestionnaire}
        onPrevPage={this.handlePrevPage}
        onNextPage={this.handleNextPage}
        isFirstPage={menuIndex === 0}
        isLastPage={menuIndex === menu.length - 1}
        isSubmitDisabled={this.checkSubmitEnabled()}
        isConfirmSubmitDialogOpen={this.state.isConfirmSubmitDialogOpen}
        isAlterDialogOpen={this.state.isAlterDialogOpen}
        toggleConfirmSubmitDialog={this.toggleConfirmSubmitDialog}
        toggleAlertSubmitDialog={this.toggleAlertSubmitDialog}
        isCompleteModalDialogOpen={this.props.isCompleteModalDialogOpen}
        toggleCompleteModalDialog={this.toggleCompleteModalDialog}
        isSubmittingQuestionnaire={this.state.isSubmittingQuestionnaire}
        showModal={this.props.showModal}
        onCancel={this.cancelModal}
        onSubmitModal={this.onSubmitModal}
        moveAwayShowModel={this.props.moveAwayShowModel}
        showSpinner={this.props.showSpinner}
        {...this.props}
      />
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  page: state.questionnaire.page,
  menu: state.questionnaire.menu,
  introData: state.questionnaire.intro,
  showSpinner: state.questionnaire.showSpinner,
  menuIndex: state.questionnaire.menuIndex,
  isMobile: state.browser.is.small || state.browser.is.extraSmall,
  moveAwayShowModel: state.questionnaire.moveAwayShowModel,
  isCompleteModalDialogOpen: state.questionnaire.isCompleteModalDialogOpen,
  showModal: state.questionnaire.showModal,
  homeTabClicked: state.questionnaire.homeTabClicked,
  chatTabClicked: state.questionnaire.chatTabClicked,
  docTabClicked: state.questionnaire.docTabClicked,
  setMoveAwaySave: state.questionnaire.setMoveAwaySave,
  userProfileClick: state.questionnaire.userProfileClick,
  helpButtonClicked: state.questionnaire.helpButtonClicked,
  hamburgerDrawerOpenClose: state.questionnaire.hamburgerDrawerOpenClose,
  headerClicked: state.questionnaire.headerClicked,
  elementUD:state.questionnaire.elementUD,
  displayPU:state.questionnaire.displayPU
});

const mapDispatchToProps = {
  push,
  updateMenu,
  // handleTabChange,
  updateIsCompleteModalDialogOpenClose,
  showHideMoveAwayPopUp,
  // setChatTabClick,
  // setHomeTabClick,
  // setDocTabClick,
  // setValueMoveAwaySave,
  // toggleOpenCloseDrawer,
  showSpinnerEnableDisable,
  displaySavePOPUP,
  elementUpdated,
};

export default connect(mapStateToProps, mapDispatchToProps)(withSnackbar(ActionsBarContainer));
